import React from 'react';
import LoginFooter from '../../components/LoginFooter';
import LoginForm from '../../components/LoginForm';
import LoginHeader from '../../components/LoginHeader';
import ErrorMsg from '../../components/ErrorMsg';

import './index.less';


const H5LoginModal = props => {
    /* eslint-disable react/prop-types */
    const {to, isNeedToVerify, captchaId, phone, code, errMsg, setErrMsg, loginFunc} = props;
    const className = 'h5-login-modal';

    return (
        <div className={className}>
            <LoginHeader to={to} />
            <ErrorMsg errMsg={errMsg} />
            <LoginForm
                params={{to, isNeedToVerify, captchaId, phone, code}}
                handleLogin={loginFunc}
                setErrMsg={setErrMsg}
            />
            <LoginFooter to={to} />
        </div>

    );
};

export default H5LoginModal;
